export const defaultNavigationConfiguration = {
    contextualSidebarBackground: '',
    contextualSidebarLinkBackground: '',
    contextualSidebarLinkColor: '',
    contextualSidebarLinkColorActive: '',
};
